var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfiles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 199,
    height: 188,
    viewBox: "0 0 199 188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 203,
    height: 194,
    transform: "translate(-0.142 0.272)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199,
    height: 188
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_3",
    "data-name": "Artboard \\u2013 3",
    clipPath: "url(#clip-Artboard_3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Asset_6_1_1_",
    "data-name": "Asset 6 1 (1)",
    transform: "translate(6.142 -6.272)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M133.886,154.744c39.461-36.883,50.8-88.855,25.323-116.084S81.091,19.257,41.631,56.139s-50.8,88.854-25.322,116.084S94.425,191.626,133.886,154.744Z",
    transform: "translate(0.198 1.644)",
    fill: "#efc003"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M110.558,22.506,43.44,6.944l.065,96.3,67.052,6.3Z",
    transform: "translate(3.185 0.509)",
    fill: "#4f84e1",
    stroke: "#4f84e1",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M44.183,94.871h84.225a18.911,18.911,0,0,1,18.906,18.9v73.549H25.286V113.767a18.91,18.91,0,0,1,18.906-18.9Z",
    transform: "translate(1.854 6.956)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M43.7,99.759h84.224a18.909,18.909,0,0,1,18.906,18.9V192.2H24.8v-73.55A18.91,18.91,0,0,1,43.7,99.759Z",
    transform: "translate(1.818 7.315)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M98.256,112.725,43.265,103.31V6.754L98.256,29.377Z",
    transform: "translate(3.172 0.495)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M43.044,6.64l83.276.123V101.34",
    transform: "translate(3.156 0.487)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M94.015,35.334l-47.55-21.1V67.315l47.55,21.364Z",
    transform: "translate(3.407 1.044)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M90.291,87.873,78.1,82.307a1,1,0,0,0-.45.213l-.131,2.149,12.617,6.081.131-.082Z",
    transform: "translate(5.684 6.035)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M93.163,126.091a12.376,12.376,0,0,0-16.133,7.8l-.6,2.01a1.273,1.273,0,1,0,2.445.712l.417-1.431a9.818,9.818,0,0,1,12.527-6.285A10.039,10.039,0,0,1,97.9,141.5l-3.14,9.775,2.429.777,3.3-10.265a12.6,12.6,0,0,0-7.327-15.693Z",
    transform: "translate(5.601 9.187)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M96.62,151.172,71.2,143.014a3.746,3.746,0,0,0-4.711,2.419l-5.467,17.019a3.743,3.743,0,0,0,2.421,4.709l25.42,8.157a3.745,3.745,0,0,0,4.711-2.419L99.04,155.88A3.743,3.743,0,0,0,96.62,151.172Z",
    transform: "translate(4.461 10.473)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M99.463,149.9l-25.42-8.157a3.745,3.745,0,0,0-4.711,2.419l-5.467,17.019a3.743,3.743,0,0,0,2.421,4.709l25.42,8.157a3.746,3.746,0,0,0,4.711-2.42l5.467-17.019A3.742,3.742,0,0,0,99.463,149.9Z",
    transform: "translate(4.67 10.38)",
    fill: "#4f84e1",
    stroke: "#4f84e1",
    strokeMiterlimit: 10,
    strokeWidth: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M84.948,157.324a3.217,3.217,0,1,0-5.274,1.332l-.851,2.656a1.4,1.4,0,1,0,2.658.85l.85-2.656a3.23,3.23,0,0,0,2.617-2.191Z",
    transform: "translate(5.768 11.228)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M75.194,137.244l-3.9-8.45",
    transform: "translate(5.228 9.444)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M74.083,139.744l-9.935-.777",
    transform: "translate(4.704 10.19)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M74.04,138.023l-9.306-6.686",
    transform: "translate(4.747 9.63)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M54.335,99.759h58.63v2.1a6.707,6.707,0,0,1-6.705,6.7H61.048a6.707,6.707,0,0,1-6.705-6.7v-2.1Z",
    transform: "translate(3.984 7.315)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M129.711,14.111l-2.626,1.114a1.658,1.658,0,0,0-.88,2.175l1.114,2.626a1.659,1.659,0,0,0,2.176.88l2.627-1.114a1.659,1.659,0,0,0,.88-2.175l-1.114-2.626A1.66,1.66,0,0,0,129.711,14.111Z",
    transform: "translate(9.244 1.025)",
    fill: "#4069df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M35.131,73.435l-4.159-.6A2.437,2.437,0,0,0,28.21,74.89L27.6,79.047a2.436,2.436,0,0,0,2.06,2.761l4.159.605a2.437,2.437,0,0,0,2.762-2.059l.605-4.157A2.436,2.436,0,0,0,35.131,73.435Z",
    transform: "translate(2.022 5.338)",
    fill: "#fd5f22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M83.9,43.221l-.31,1.279a.768.768,0,0,0,.566.927l1.28.309a.769.769,0,0,0,.928-.566l.31-1.279a.768.768,0,0,0-.566-.927l-1.28-.309A.769.769,0,0,0,83.9,43.221Z",
    transform: "translate(6.128 3.126)",
    fill: "#b17ed3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M76.423,21.465l-.433-.188A.356.356,0,0,1,75.8,20.8l.188-.433A.351.351,0,0,0,75.8,19.9l-.94-.4a.351.351,0,0,0-.474.188l-.188.433a.356.356,0,0,1-.474.188l-.433-.188a.351.351,0,0,0-.474.188l-.4.94a.351.351,0,0,0,.188.474l.433.188a.356.356,0,0,1,.188.474l-.188.433a.351.351,0,0,0,.188.474l.94.4a.351.351,0,0,0,.474-.188l.188-.433a.356.356,0,0,1,.474-.188l.433.188a.351.351,0,0,0,.474-.188l.4-.94A.351.351,0,0,0,76.423,21.465Z",
    transform: "translate(5.308 1.427)",
    fill: "#f38539"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M91.137,86.16,89.42,87.59,89.4,90.483a.114.114,0,0,0,.188.09L91.088,89l.049-2.836Z",
    transform: "translate(6.555 6.318)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M90.258,87.912,77.968,82.3l.744-.531,11.276,5.092,1.194-.989.965.335",
    transform: "translate(5.717 5.995)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfiles);
export default __webpack_public_path__ + "static/media/profiles.9a296349.svg";
export { ForwardRef as ReactComponent };